// export function xml2json(xml) {

//   // Create the return object
//   var obj = {};

//   if (xml.nodeType == 1) { // element
//     // do attributes
//     if (xml.attributes.length > 0) {
//     // obj["@attributes"] = {};
//       for (var j = 0; j < xml.attributes.length; j++) {
//         var attribute = xml.attributes.item(j);
//         obj[attribute.nodeName] = attribute.nodeValue;
//       }
//     }

//   } else if (xml.nodeType == 3) { // text
//     obj = xml.nodeValue;
//   }

//   // do children
//   if (xml.hasChildNodes()) {

//     for(var i = 0; i < xml.childNodes.length; i++) {
//       var item = xml.childNodes.item(i);
//       var nodeName = item.nodeName;

//       if (typeof(obj[nodeName]) == "undefined") {
//         if( nodeName == '#text') obj = xml2json(item);
//         else obj[nodeName] = xml2json(item);

//       } else {

//         if (typeof(obj[nodeName].push) == "undefined") {
//           var old = obj[nodeName];
//           obj[nodeName] = [];
//           obj[nodeName].push(old);
//         }
//         obj[nodeName].push(xml2json(item));
//       }
//     }

//   }

//   if( count(obj) === 1 ) return obj[getIndex(obj)]
//   else return obj;

// };

export class XML {
	constructor(xml) {
		this.keyModify = null;
		this.ignore = null;

		this.loadXml = new Promise((resolve, reject) => {
			if (typeof xml == 'string') {
				let parse = new DOMParser();
				resolve(parse.parseFromString(xml, 'text/xml'));
			} else if (typeof xml == 'object' && xml instanceof File) {
				let Reader = new FileReader();
				let parse = new DOMParser();

				Reader.onload = (file) => {
					file = file.target.result.replace(
						'data:text/xml;base64,',
						''
					);
					file = window.atob(file);
					resolve(parse.parseFromString(file, 'text/xml'));
				};

				Reader.readAsDataURL(xml);
			} else if (typeof xml == 'object' && xml instanceof DOMParser) {
				resolve(xml);
			} else {
				reject();
			}
		});
	}

	count(obj) {
		if (typeof obj != 'object') return false;
		let i = 0;
		for (let key in obj) i++;
		return i;
	}

	getIndex(obj) {
		if (typeof obj != 'object') return false;
		for (let key in obj) return key;
	}

	getKey(key) {
		if (typeof this.keyModify != 'function') return key;
		else return this.keyModify(key);
	}

	async simpleObj(pxml = null) {
		// Create the return object
		let obj = {};
		let xml = pxml || (await this.loadXml);

		if (xml.attributes != undefined && xml.attributes.length > 0) {
			for (var j = 0; j < xml.attributes.length; j++) {
				var attribute = xml.attributes.item(j);
				obj[this.getKey(attribute.nodeName)] = attribute.nodeValue;
			}
		}

		if (xml.nodeType == 3) obj = xml.nodeValue;

		// do children
		if (xml.hasChildNodes()) {
			for (var i = 0; i < xml.childNodes.length; i++) {
				var item = xml.childNodes.item(i);
				var nodeName = item.nodeName;

				if (typeof this.ignore == 'function') {
					if (this.ignore(nodeName, item)) {
						continue;
					}
				}

				if (typeof obj[this.getKey(nodeName)] == 'undefined') {
					if (nodeName == '#text') {
						if (this.count(obj) === 0)
							obj = await this.simpleObj(item);
						else obj['text'] = await this.simpleObj(item);
					} else {
						if (typeof obj == 'string') obj = { text: obj };
						obj[this.getKey(nodeName)] = await this.simpleObj(item);
					}
				} else {
					if (typeof obj[this.getKey(nodeName)].push == 'undefined') {
						var old = obj[this.getKey(nodeName)];
						obj[this.getKey(nodeName)] = [];
						obj[this.getKey(nodeName)].push(old);
					}
					obj[this.getKey(nodeName)].push(await this.simpleObj(item));
				}
			}
		}

		if (this.count(obj) === 1) return obj[this.getIndex(obj)];
		else return obj;
	}

	async getObj(pxml = null) {
		// Create the return object
		var obj = {};
		let xml = pxml || (await this.loadXml);

		if (xml.nodeType == 1) {
			// element
			// do attributes
			if (xml.attributes.length > 0) {
				obj['@attributes'] = {};
				for (var j = 0; j < xml.attributes.length; j++) {
					var attribute = xml.attributes.item(j);
					obj['@attributes'][this.getKey(attribute.nodeName)] =
						attribute.nodeValue;
				}
			}
		} else if (xml.nodeType == 3) {
			// text
			obj = xml.nodeValue;
		}

		// do children
		if (xml.hasChildNodes()) {
			for (var i = 0; i < xml.childNodes.length; i++) {
				var item = xml.childNodes.item(i);
				var nodeName = item.nodeName;

				if (typeof this.ignore == 'function') {
					if (this.ignore(nodeName, item)) {
						continue;
					}
				}

				if (typeof obj[this.getKey(nodeName)] == 'undefined') {
					obj[this.getKey(nodeName)] = await this.getObj(item);
				} else {
					if (typeof obj[this.getKey(nodeName)].push == 'undefined') {
						var old = obj[this.getKey(nodeName)];
						obj[this.getKey(nodeName)] = [];
						obj[this.getKey(nodeName)].push(old);
					}
					obj[this.getKey(nodeName)].push(await this.getObj(item));
				}
			}
		}
		return obj;
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/xml.js